import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import ReactGA from 'react-ga4';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Cookies from 'js-cookie';

// List of supported languages
const supportedLanguages = ['en', 'nl', 'fr', 'de'];

const root = ReactDOM.createRoot(document.getElementById('root'));

// Initialize Google Analytics
ReactGA.initialize('G-LLDPY3X8GS');

// Initialize i18next and then render the app
i18n
  .init()
  .then(() => {
    // Get the current language from cookies and extract the base language
    const currentLanguage = Cookies.get('i18next')?.split('-')[0] || 'en'; // This extracts the base language (e.g., 'en' from 'en-US')

    // Set the lang attribute on the html element
    document.documentElement.lang = currentLanguage;

    // Render the application
    root.render(
      <I18nextProvider i18n={i18n}>
        <Router>
          <Routes>
            {/* Redirect to the default language based on the current language */}
            <Route
              path="/"
              element={
                currentLanguage === 'en' ? (
                  <App lang={currentLanguage} />
                ) : (
                  <Navigate to={`/${currentLanguage}`} replace /> // Redirect to /fr, /nl, or /de
                )
              }
            />

            {/* Generate language routes dynamically */}
            {supportedLanguages.map((lang) => (
              <Route
                key={lang}
                path={`/${lang}/*`}
                element={<App lang={lang} />}
              />
            ))}
          </Routes>
        </Router>
      </I18nextProvider>
    );
  })
  .catch((error) => {
    console.error('Error initializing i18next:', error);
    // Optionally render an error component or message here
  });
